import React from 'react';

export const AskAiIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      focusable="false"
      style={{ 
        width: '16px', 
        height: '16px',
        filter: 'drop-shadow(0 0 4px rgba(59, 130, 246, 0.3))'
      }}
    >
      <defs>
        <linearGradient id="aiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="50%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#06B6D4" />
        </linearGradient>
        
        <linearGradient id="sparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#EF4444" />
        </linearGradient>
        
        <filter id="glow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <g style={{
        transformOrigin: '12.2px 2.3px',
        animation: 'sparkle 2s ease-in-out infinite alternate'
      }}>
        <path
          d="M15 1.875c-1.678 0-1.875-.197-1.875-1.875h-.938c0 1.678-.196 1.875-1.874 1.875v.938c1.678 0 1.874.196 1.874 1.874h.938c0-1.678.197-1.875 1.875-1.875v-.937z"
          fill="url(#sparkleGradient)"
          style={{ filter: 'url(#glow)' }}
        />
      </g>
      
      <g style={{
        transformOrigin: '8px 8px',
        animation: 'pulse 3s ease-in-out infinite'
      }}>
        <path
          fillRule="evenodd"
          d="M6.563 15H7.5a6.57 6.57 0 016.563-6.563V7.5A6.57 6.57 0 017.5.937h-.938A6.57 6.57 0 010 7.5v.938A6.57 6.57 0 016.563 15zm.468-2.616A7.547 7.547 0 002.616 7.97 7.547 7.547 0 007.03 3.553a7.547 7.547 0 004.416 4.416 7.547 7.547 0 00-4.416 4.415z"
          clipRule="evenodd"
          fill="url(#aiGradient)"
        />
      </g>
      
      <style>{`
        @keyframes sparkle {
          0% { 
            transform: rotate(0deg) scale(1);
            opacity: 0.8;
          }
          100% { 
            transform: rotate(5deg) scale(1.1);
            opacity: 1;
          }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
          }
          50% { 
            transform: scale(1.02);
          }
        }
      `}</style>
    </svg>
  );